import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useFieldModel } from '@src/components/shared/form_fields/useFieldModel';
import { useSuggestedEmailProvider } from '@src/components/shared/form_fields/useSuggestedEmailProvider';
import { useMailHostList } from '@src/components/shared/useMailHostList';
import TextFormInput from '@src/components/shared/form_elements/TextFormInput.vue';
import { useAriaDescribedby } from '@src/components/shared/composables/useAriaDescribedby';
import { computed, useSlots } from 'vue';
import FieldContainer from '@src/components/patterns/FieldContainer.vue';
import { useValueEqualsPlaceholderWarning } from '@src/components/shared/composables/useValueEqualsPlaceholderWarning';
import { useI18n } from 'vue-i18n';

interface Props {
	modelValue: string;
	showError: boolean;
	id?: string;
	inputId?: string;
	isMaxWidthField?: boolean;
	ariaDescribedby?: string | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailField',
  props: {
    modelValue: {},
    showError: { type: Boolean },
    id: { default: 'address-form-email' },
    inputId: { default: 'email' },
    isMaxWidthField: { type: Boolean },
    ariaDescribedby: {}
  },
  emits: [ 'update:modelValue', 'field-changed' ],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { t } = useI18n();
const slots = useSlots();

const mailHostList = useMailHostList();
const fieldModel = useFieldModel<string>( () => props.modelValue, props.modelValue );
const { suggestedProvider, onSuggestionClicked } = useSuggestedEmailProvider( fieldModel, mailHostList, emit as ( event: string, value: any ) => void );
const valueEqualsPlaceholderWarning = useValueEqualsPlaceholderWarning( fieldModel, t( 'donation_form_email_placeholder' ), 'donation_form_email_placeholder_warning' );
const ariaDescribedby = useAriaDescribedby(
	props.inputId,
	computed<boolean>( () => false ),
	computed<boolean>( () => props.showError ),
	computed<boolean>( () => valueEqualsPlaceholderWarning.hasWarning.value || !!slots.message ),
	computed<string | undefined>( () => props.ariaDescribedby )
);

const onInput = (): void => {
	if ( props.showError ) {
		emit( 'field-changed', 'email' );
	}
};

const onUpdateModel = ( newValue: string ): void => {
	emit( 'update:modelValue', newValue );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FieldContainer, {
    "input-id": __props.inputId,
    "show-error": __props.showError,
    id: __props.id,
    "is-max-width-field": __props.isMaxWidthField
  }, _createSlots({
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t( 'donation_form_email_label' )), 1)
    ]),
    field: _withCtx(() => [
      _createVNode(TextFormInput, {
        "input-type": "text",
        "input-id": __props.inputId,
        name: "email",
        placeholder: _ctx.$t( 'form_for_example', { example: _ctx.$t( 'donation_form_email_placeholder' ) } ),
        autocomplete: "email",
        modelValue: _unref(fieldModel),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldModel) ? (fieldModel).value = $event : null)),
          onUpdateModel
        ],
        "has-error": __props.showError,
        "has-message": _unref(suggestedProvider) !== '',
        "aria-describedby": _unref(ariaDescribedby),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('field-changed', 'email'))),
        onInput: onInput
      }, null, 8, ["input-id", "placeholder", "modelValue", "has-error", "has-message", "aria-describedby"])
    ]),
    error: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t( 'donation_form_email_error' )), 1)
    ]),
    _: 2
  }, [
    (_unref(suggestedProvider))
      ? {
          name: "message",
          fn: _withCtx(() => [
            _createElementVNode("button", {
              class: "link-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(onSuggestionClicked)( _unref(suggestedProvider) ))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_unref(onSuggestionClicked)( _unref(suggestedProvider) )), ["enter","space"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t( 'donation_form_email_suggestion' )) + " ", 1),
              _createElementVNode("strong", null, _toDisplayString(_unref(suggestedProvider)), 1),
              _cache[4] || (_cache[4] = _createTextVNode("? ", -1))
            ], 32)
          ]),
          key: "0"
        }
      : (_ctx.$slots.message)
        ? {
            name: "message",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "message")
            ]),
            key: "1"
          }
        : undefined
  ]), 1032, ["input-id", "show-error", "id", "is-max-width-field"]))
}
}

})